import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import NumberInput from '@react/react-spectrum/NumberInput'
import Select from '@react/react-spectrum/Select'
import Switch from '@react/react-spectrum/Switch'
import Textfield from '@react/react-spectrum/Textfield'

import MediaUpload from 'components/MediaUpload'
import { RichTextFormField } from 'components/RichTextEditor'
import { ScreenPicker } from '../../ScreenPicker'

const Heading = ({ screen, project, projectConfig, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Summary'>
        <RichTextFormField
          label='Page Summary'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Image' labelFor='image'>
        <Switch
          label='Full width'
          checked={!!content.isFullWidthBanner}
          onChange={(v) => !disabled && onChange('isFullWidthBanner')(v)}
        />
        <Switch
          label='Display&nbsp;Image'
          checked={!!content.showBanner}
          onChange={(v) => !disabled && onChange('showBanner')(v)}
        />
        <MediaUpload
          type='image'
          value={content.image || ''}
          maxHeight='100px'
          onUpload={onChange('image')}
          projectId={project?.meta?.id}
          path={`category-${screen?.meta?.name}-image`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Image Text Position'>
        <Select
          aria-label='Image Text Position'
          options={projectConfig.bannerPositionOptions}
          placeholder={'Select an option'}
          name='bannerTextPosition'
          value={content.bannerTextPosition || ''}
          onChange={onChange('bannerTextPosition')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Hero Title'>
        <Textfield
          placeholder='Title'
          name='heroTitle'
          value={content.heroTitle || ''}
          onChange={onChange('heroTitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Hero Description'>
        <Textfield
          placeholder='Description'
          name='heroDescription'
          value={content.heroDescription || ''}
          onChange={onChange('heroDescription')}
          disabled={disabled}
          multiLine
        />
      </FieldLabel>

      <FieldLabel label='Button Label'>
        <Textfield
          placeholder='Button Label'
          name='buttonLabel'
          value={content.buttonLabel || ''}
          onChange={onChange('buttonLabel')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Button Link'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          value={content.buttonLink || ''}
          onChange={onChange('buttonLink')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

const ChildScreens = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Column Count' labelFor='product-page-column-count'>
        <NumberInput
          id='product-page-column-count'
          min={1}
          max={4}
          value={content.columnCount || 1}
          onChange={onChange('columnCount')}
          disabled={disabled}
        />
      </FieldLabel>
      <Switch
        label='Select multiple'
        checked={!!content.selectMultiple}
        onChange={(v) => !disabled && onChange('selectMultiple')(v)}
      />
      <ScreenPicker
        screenName={screen?.meta?.name}
        screens={content.list || ''}
        onChange={onChange('list')}
        disabled={disabled}
        multiple
      />
    </>
  )
}

const Action = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Button Label'>
        <Textfield
          placeholder='Button Label'
          name='actionButtonLabel'
          value={content.actionButtonLabel || ''}
          onChange={onChange('actionButtonLabel')}
          disabled={disabled}
        />
      </FieldLabel>
      <FieldLabel label='Redirect Target'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          value={content.actionButtonTarget || ''}
          onChange={onChange('actionButtonTarget')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

export default [
  { label: 'Heading', content: Heading },
  { label: 'Child Screens', content: ChildScreens },
  { label: 'Action', content: Action },
]
